import { useSelector } from "react-redux";
import { hasEmptyNode } from "../../../abstract/redux/slice/structureSlice";
import styles from "./ButtonGenerate.module.scss";
import { useRef } from "react";
import { getWindowLock } from "../../../abstract/redux/slice/overlaySlice";

export function ButtonGenerate({ handler, text }) {
  const ref = useRef(null);
  const isEmpty = useSelector(hasEmptyNode);
  const isLocked = useSelector(getWindowLock);

  const data = text.split("\n");

  const handleOnMouseDown = (e) => {
    e?.preventDefault();

    ref?.current?.focus();
    
    if (!isEmpty) {
      handler();
    } else if (!isLocked) {
      ref?.current?.focus();
    }
  };

  return (
    <div className={styles['container']}>

    <button
      className={`${styles["style--generate"]}`}
      ref={ref}
      onMouseDown={handleOnMouseDown}>
      {data.map((e, index) => (
        <div className={styles["button--text"]} key={`${index} ${e}`}>
          {e}
        </div>
      ))}
    </button>
      </div>
  );
}
